













import { Component, Vue, Prop } from 'vue-property-decorator';
import { ICart, ICartItem, IProduct } from '@/models/CartModels';
import VueBase from '@/VueBase.vue';

@Component({})
export default class CartMenuItem extends VueBase {
  @Prop(Object)
  public cart!: ICart;

  public get items(): ICartItem[] {
    return this.cart.items || [];
  }

  public goTo() {
    this.$router.push({name: 'viewCart', params: {id: this.cart.title}});
  }
}
